/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* Footer menu accordions (mobile) */
  var footerMenuTitle = document.querySelectorAll('.footer__block.footer__block--menu .footer__block__title');
  footerMenuTitle.forEach(function(el) {
    el.addEventListener('click', function() {
      el.classList.toggle('open');
    });
  });

  /* Review slider - change every 7 seconds */
  var reviewSliderButton = document.querySelectorAll(".reviews.reviews--section .slider__button--next");
  if (reviewSliderButton != null) {
    reviewSliderButton.forEach(function(btn){
      setInterval(function(){
        btn.click();
      },7000);      
    })
  }

  let observer = new IntersectionObserver((entries, observer) => { 
    entries.forEach(entry => {
      if(entry.isIntersecting){
        if(entry.intersectionRatio >= 0.55){
          let index = entry.target.dataset.mediaIndex;
          document.querySelectorAll('.product-images-nav span').forEach(dot => {
            if(dot.dataset.mediaIndex == index) {
              dot.classList.add('active');
            } else {
              dot.classList.remove('active');
            }
          });
        }
      }
    });
  }, {threshold: 0.55});
  
  document.querySelectorAll('.product__slide').forEach(image => { observer.observe(image) });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();